module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consultTeacher"
  }, [_c('div', {
    staticClass: "consultTeacherMain"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "TeacherList"
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "teacherCell"
    }, [_c('div', {
      staticStyle: {
        "width": "110px"
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": item.cover
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-content"
    }, [_c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('span', {
      staticClass: "money-symbol"
    }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
      staticClass: "money-num"
    }, [_vm._v(_vm._s(item.price))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "to-buy",
      class: {
        'disabled': item.count == 0 && item.infinite == 0
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item)
        }
      }
    }, [_vm._v("去抢购")]), _vm._v(" "), (item.infinite !== 1) ? _c('div', {
      staticClass: "num"
    }, [_vm._v("库存: " + _vm._s(item.count))]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "closeBtn",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png"
    },
    on: {
      "click": _vm.closeBtnClicked
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("商品列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad5dd668"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/goodsList/index.vue
// module id = 387
// module chunks = 0